import React, { Component } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { StepConnector } from "@material-ui/core";

export default class Stepperr extends Component {
  state = {
    activeSteps: []
  };
  render() {
    const language = this.props.language;
    if (this.props.isCancelled) {
      return (
        <div>
          <Stepper
            activeStep={this.props.activeStep}
            orientation="vertical"
            dir={language == "english" ? "ltr" : "rtl"}
            connector={
              <StepConnector
                classes={{
                  lineVertical: language == "arabic" && "vertical-line-arabic",
                  root: language == "arabic" && "vertical-line-arabic-root"
                }}
              />
            }
          >
            <Step key={"Cancelled"}>
              <StepLabel
                classes={{
                  label:
                    language == "english"
                      ? "larger-text-tracking"
                      : "larger-text-tracking-arabic",
                  iconContainer:
                    language == "arabic" && "step-label-icon-container-arabic"
                }}
              >
                {this.props.language == "english"
                  ? "Order Cancelled"
                  : "تم رفض الطلب"}
              </StepLabel>
              <StepContent
                classes={{
                  root: language == "arabic" && "step-content-arabic"
                }}
              >
                <p
                  className={"text-muted ".concat(
                    language == "english" ? "text-left" : "text-right mr-2"
                  )}
                >
                  {this.props.language == "english"
                    ? "The store could not accept your order"
                    : "لم يتمكن المتجر من استقبال طلبك"}
                </p>
              </StepContent>
            </Step>
          </Stepper>
        </div>
      );
    } else if (!this.props.isCancelled)
      return (
        <div>
          <Stepper
            activeStep={this.props.activeStep}
            orientation="vertical"
            dir={language == "english" ? "ltr" : "rtl"}
            connector={
              <StepConnector
                classes={{
                  lineVertical: language == "arabic" && "vertical-line-arabic",
                  root: language == "arabic" && "vertical-line-arabic-root"
                }}
              />
            }
          >
            {this.props.isCancelled && (
              <Step key={"Cancelled"}>
                <StepLabel
                  classes={{
                    label:
                      language == "english"
                        ? "larger-text-tracking"
                        : "larger-text-tracking-arabic",
                    iconContainer:
                      language == "arabic" && "step-label-icon-container-arabic"
                  }}
                >
                  {this.props.language == "english"
                    ? "Order Cancelled"
                    : "تم رفض الطلب"}
                </StepLabel>
                <StepContent
                  classes={{
                    root: language == "arabic" && "step-content-arabic"
                  }}
                >
                  <p
                    className={"text-muted ".concat(
                      language == "english" ? "text-left" : "text-right mr-2"
                    )}
                  >
                    {this.props.language == "english"
                      ? "The store could not accept your order"
                      : "لم يتمكن المتجر من استقبال طلبك"}
                  </p>
                </StepContent>
              </Step>
            )}

            <Step key={"New"}>
              <StepLabel
                classes={{
                  label:
                    language == "english"
                      ? "larger-text-tracking"
                      : "larger-text-tracking-arabic",
                  iconContainer:
                    language == "arabic" && "step-label-icon-container-arabic"
                }}
              >
                {this.props.language == "english"
                  ? "Order Placed"
                  : "تم ارسال الطلب"}
              </StepLabel>
              <StepContent
                classes={{
                  root: language == "arabic" && "step-content-arabic"
                }}
              >
                <p
                  className={"text-muted ".concat(
                    language == "english" ? "text-left" : "text-right mr-2"
                  )}
                >
                  {this.props.language == "english"
                    ? "Thank you for placing your order."
                    : "شكرا لوضع طلبك."}
                </p>
              </StepContent>
            </Step>
            <Step key={"Received"}>
              <StepLabel
                classes={{
                  label:
                    language == "english"
                      ? "larger-text-tracking"
                      : "larger-text-tracking-arabic",
                  iconContainer:
                    language == "arabic" && "step-label-icon-container-arabic"
                }}
              >
                {language == "english" ? "Order Received" : "تم استلام الطلب"}
              </StepLabel>
              <StepContent
                classes={{
                  root: language == "arabic" && "step-content-arabic"
                }}
              >
                <p
                  className={"text-muted ".concat(
                    language == "english" ? "text-left" : "text-right mr-2"
                  )}
                >
                  {language == "english"
                    ? "We have seen your order and are processing it now."
                    : "تم استلام طلبك وجاري معالجته"}
                </p>
              </StepContent>
            </Step>
            <Step key={"Preparing"}>
              <StepLabel
                classes={{
                  label:
                    language == "english"
                      ? "larger-text-tracking"
                      : "larger-text-tracking-arabic",
                  iconContainer:
                    language == "arabic" && "step-label-icon-container-arabic"
                }}
              >
                {language == "english" ? "Preparing" : "جاري تحضير الطلب"}
              </StepLabel>
              <StepContent
                classes={{
                  root: language == "arabic" && "step-content-arabic"
                }}
              >
                <p
                  className={"text-muted ".concat(
                    language == "english" ? "text-left" : "text-right mr-2"
                  )}
                >
                  {language == "english"
                    ? "Your order is now being prepared"
                    : "جاري تجهيز طلبك"}
                </p>
              </StepContent>
            </Step>
            {!this.props.isPickup && (
              <Step key={"Delivery"}>
                <StepLabel
                  classes={{
                    label:
                      language == "english"
                        ? "larger-text-tracking"
                        : "larger-text-tracking-arabic",
                    iconContainer:
                      language == "arabic" && "step-label-icon-container-arabic"
                  }}
                >
                  {language == "english" ? "Out for Delivery" : "جاري التوصيل"}
                </StepLabel>
                <StepContent
                  classes={{
                    root: language == "arabic" && "step-content-arabic"
                  }}
                >
                  <p
                    className={"text-muted ".concat(
                      language == "english" ? "text-left" : "text-right mr-2"
                    )}
                  >
                    {language == "english"
                      ? "Your order is out for delivery now."
                      : "طلبك الان في طريقه اليك"}
                  </p>
                </StepContent>
              </Step>
            )}
            <Step key={"Complete"}>
              <StepLabel
                classes={{
                  label:
                    language == "english"
                      ? "larger-text-tracking"
                      : "larger-text-tracking-arabic",
                  iconContainer:
                    language == "arabic" && "step-label-icon-container-arabic"
                }}
              >
                {language == "english" ? "Complete" : "اكتمل الطلب"}
              </StepLabel>
              <StepContent
                classes={{
                  root: language == "arabic" && "step-content-arabic"
                }}
              >
                <p
                  className={"text-muted ".concat(
                    language == "english" ? "text-left" : "text-right mr-2"
                  )}
                >
                  {language == "english"
                    ? "Your order has been delivered. Enjoy!"
                    : "تم توصيل طلبك بنجاح"}
                </p>
              </StepContent>
            </Step>
          </Stepper>
        </div>
      );
  }
}
